module.exports = __webpack_public_path__ + "img/pf.cd51dc2.svg";